import React, { useMemo, useState } from 'react';
import Select from 'react-select';
import { useTeam } from '../context/TeamContext';
import { selectStyles } from '../ui/pickers';
import useJson from '../utils/useJson';
import './TeamSelectModal.css';

// Shown after sign-in until the user says which program they're with; every report then
// reads that team. There is no way to close it without choosing.
export default function TeamSelectModal() {
  const { setSelectedTeam } = useTeam();
  const [choice, setChoice] = useState(null);
  const teams = useJson('/api/teams/tracked', (j) => (Array.isArray(j.teams) ? j.teams : []));
  const options = useMemo(() => (teams.data || []).map((t) => ({ label: t.name, value: t.code })), [teams.data]);
  const styles = useMemo(() => selectStyles({ height: 46 }), []);

  return (
    <div className="tsm-backdrop">
      <div className="tsm-card" role="dialog" aria-label="Choose your program">
        <h2>What program are you a part of:</h2>
        <p>Your hitting, pitching, and defense reports will show this team's players.</p>
        {teams.loading && <div className="tsm-status">Loading teams…</div>}
        {teams.error && <div className="tsm-status is-error">{teams.error === 'Request failed.' ? 'Could not load teams' : teams.error}</div>}
        {teams.data && (
          <>
            <Select options={options} value={choice} onChange={setChoice} placeholder="Search team..." styles={styles}
              maxMenuHeight={280} noOptionsMessage={() => 'No teams found'} />
            <button type="button" className="tsm-go" disabled={!choice}
              onClick={() => choice && setSelectedTeam({ code: choice.value, name: choice.label })}>Continue</button>
          </>
        )}
      </div>
    </div>
  );
}
